<template>
  <div v-if="active && !big" class="golden_sticker" style="position:absolute;z-index:11900;line-height:9px;width:60px;height:60px;overflow:none;border-radius:30px;font-size:10px;">
    <div style="font-size:16px;font-weight:500;line-height:16px;margin-top:7px;">{{unity}}</div>
    ou mais,<br/>preço de atacado
  </div>
  <div v-else-if="active && big" class="golden_sticker" style="position:absolute;z-index:18900;line-height:14px;width:100px;height:100px;overflow:none;border-radius:50px;font-size:14px;">
    <div style="font-size:30px;font-weight:500;line-height:16px;margin-top:18px;margin-bottom:8px;">{{unity}}</div>
    ou mais<br/>preço de atacado
  </div>
</template>

<script>

import _ from 'lodash'

export default {
  props: ['productView', 'big'],

  data () {
    return {
      active: false,
      unity: 0
    }
  },

  created () {
    if (this.productView.promotional_conditionals && this.productView.promotional_conditionals.length){
      this.active = true
      let promos = _.clone(this.productView.promotional_conditionals)
      promos.sort((a, b) => {
        return a.number_of_products_to_promo - b.number_of_products_to_promo
      })
      this.unity = promos[0].number_of_products_to_promo
    }
  }

}
</script>

<style lang ="scss">
.golden_sticker{
  font-family:"Roboto-Medium";
  background-image: linear-gradient(to right, #efe464, #ffd65e, #916f0b);
  color: #222;
  font-weight:500;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
  text-shadow: 1px 1px #fff;
}
</style>
